import { CaseEventCategory } from "apps/platform-client/client/src/models/generated/graphql";

export const mapEventCategoryToColor = (eventCategory: CaseEventCategory): [string, string] => {
	switch (eventCategory) {
		case CaseEventCategory.System:
			return ["#fff4dc", "#a87511"];
		case CaseEventCategory.Chat:
			return ["#d8f3ff", "#036ed1"];
		case CaseEventCategory.DataAddition:
			return ["#daddfe", "#614faa"];
		case CaseEventCategory.FinanciallyRelevant:
			return ["#ccf6f2", "#007178"];
		case CaseEventCategory.Negotiation:
			return ["#c6dbb7", "#82a469"];
		default:
			return ["#5e6e7d", "#5e6e7d"];
	}
};
